var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.900391,
    y: 0.68631,
    width: 50.4863,
    height: 50.4863,
    rx: 8.07781,
    fill: "#FD7401"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_10258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0557 16.8419H35.2307C35.4985 16.8419 35.7554 16.9483 35.9447 17.1377C36.1341 17.327 36.2405 17.5838 36.2405 17.8516V34.0073C36.2405 34.2751 36.1341 34.5319 35.9447 34.7213C35.7554 34.9106 35.4985 35.017 35.2307 35.017H17.0557C16.7879 35.017 16.531 34.9106 16.3417 34.7213C16.1523 34.5319 16.0459 34.2751 16.0459 34.0073V17.8516C16.0459 17.5838 16.1523 17.327 16.3417 17.1377C16.531 16.9483 16.7879 16.8419 17.0557 16.8419ZM34.221 21.1211L26.2159 28.2902L18.0654 21.0989V32.9975H34.221V21.1211ZM18.5814 18.8614L26.2048 25.5882L33.7182 18.8614H18.5814Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_10258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.2334,
    height: 24.2334,
    fill: "white",
    transform: "translate(14.0268 13.8127)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.afeb44aa20e5cd706066f3aa6b531a6d.svg";
export { ForwardRef as ReactComponent };